import './HomeButton.scss';

import { HomeIcon } from 'app/agriculture/icons';
import { primaryColourText } from 'app/agriculture/material';
import { useFarm } from 'app/agriculture/hooks/useFarm/useFarm';
import { useFlyToFarm } from 'app/agriculture/hooks/useFlyTo/useFlyToFarm';
import { useCallback } from 'react';

export function HomeButton() {
    const {
        farm: { center, viewRotation, viewAngle, viewHeight },
    } = useFarm();
    const { flyToFarm } = useFlyToFarm();

    const handleClick = useCallback(() => {
        flyToFarm({ center, viewRotation, viewAngle, viewHeight });
    }, [center, flyToFarm, viewAngle, viewHeight, viewRotation]);

    return (
        <button className="HomeButton" onClick={handleClick}>
            <HomeIcon color={primaryColourText} />
        </button>
    );
}
